import React, { Component } from "react";
import { Nav, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import CSROI from "../../assets/CS_ROI.png";
import Mospi from "../../assets/logo-mospi-7.png";
import LogoIN from "../../assets/Invest-India-Horizontal-Logo 2.png";
import LogoPMIndia from "../../assets/logo-pm-india.png";
import LogoPragati from "../../assets/logo-pragati.png";
import emailIcon from "../../assets/email.png";
import { getLocalstorage, isValidArray, scrollToPosition } from "../../helper";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TermsCondition from "../footer/TermsConditions";
import PrivacyPolicy from "../footer/PrivacyPolicy";
import CopyrightPolicy from "../footer/CopyrightPolicy";
import HyperLinkingPolicy from "../footer/HyperLinkingPolicy";
import NeedHelpModal from "../../container/front/NeedHelpModal";
import linkedIn from "../../assets/linkedinsmall.png";
import PMGSL from "../../assets/pmgsl.png";
import { PATHS, STATUS } from "../../constant";
import Email_Icon from "../../assets/Email_Icon.svg";
import Landline_Icon from "../../assets/Landline_Icon.svg";

class Footer extends Component {
  state = {
    isBannerModalVisible: false,
    bannerContent: "",
    footerLogos: [
      {
        imageUrl: CSROI,
        src: "https://cabsec.gov.in/"
      },
      {
        imageUrl: LogoPMIndia,
        src: "https://www.pmindia.gov.in/en/"
      },
      {
        imageUrl: LogoPragati,
        src: "https://pragati.nic.in/en/"
      },
      {
        imageUrl: PMGSL,
        src: "https://pmgatishakti.gov.in/pmgatishakti/"
      },
      {
        imageUrl: Mospi,
        src: "https://paimana-crip.mospi.gov.in/home"
      }
    ]
  };

  scrollToContainer = id => () => {
    const elem = document.getElementById(id);
    const height = document.getElementsByTagName("header")[0].clientHeight;
    scrollToPosition({ top: elem.offsetTop - height });
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };

  onClickNeedHelpModal = () => {
    this.setState(prevState => ({
      showNeedHelpModal: !prevState.showNeedHelpModal
    }));
  };

  render() {
    const { onClickNeedHelpModal } = this;
    const {
      showNeedHelpModal,
      footerLogos,
      bannerContent,
      isBannerModalVisible
    } = this.state;
    let settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    };

    let isLoggedIn = !!getLocalstorage("token");
    let needHelpEmails = getLocalstorage("needHelpEmails");
    let primaryMail, secondaryMail;

    if (isLoggedIn && needHelpEmails && needHelpEmails.length) {
      primaryMail = needHelpEmails[0];
      secondaryMail = needHelpEmails[1];
    }
    let pmgInvestIndiaMail = isLoggedIn
      ? primaryMail
        ? primaryMail
        : "pmg@investindia.org.in"
      : "pmg[at]investindia[dot]org[dot]in";
    let pmgSupportMail = isLoggedIn
      ? primaryMail
        ? secondaryMail
          ? secondaryMail
          : null
        : "pmg-support@investindia.org.in"
      : "pmg-support[at]investindia[dot]org[dot]in";

    return (
      <footer className="front-footer-wrapper">
        <div className="container">
          <Slider {...settings} className="footer-logos">
            {isValidArray(footerLogos) &&
              footerLogos.map((logo, index) => {
                return (
                  <div className="slide-item" key={`footer-logo-${index}`}>
                    <a
                      href={logo.src}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={logo.imageUrl}
                        alt="Logo"
                        style={{
                          width:
                            logo.src ==
                            "https://pmgatishakti.gov.in/pmgatishakti/"
                              ? "20vw"
                              : ""
                        }}
                        loading="lazy"
                      />
                    </a>
                  </div>
                );
              })}
          </Slider>
          <div className="footer-need-help">
            <div className="need-help-left">
              {/* <img src={emailIcon} alt="emails" /> */}
              <span>Need Help ?</span>
            </div>
            <div className="need-help-right">
              <img
                src={Email_Icon}
                alt="emails"
                style={{ width: "18px", marginRight: "5px" }}
                loading="lazy"
              />
              <a
                href="mailto:pmg@investindia.org.in"
                style={{ paddingTop: "28px" }}
              >
                {pmgInvestIndiaMail}
              </a>
            </div>
            <div className="need-help-modify">
              <img
                src={Landline_Icon}
                alt="landline"
                className="contact-icon"
                style={{ width: "16px", marginRight: "5px", marginTop: 0 }}
                loading="lazy"
              />
              <span className="contact-landline" style={{ paddingTop: "28px" }}>
                (011) 26773798
              </span>
            </div>
            {/* <div className="social-media">
              <a
                style={{ display: "flex", alignItems: "center", margin: 0 }}
                href={
                  "https://www.linkedin.com/company/project-monitoring-group/"
                }
                target="_blank"
              >
                <Image
                  src={linkedIn}
                  style={{
                    width: "22px",
                    display: "block"
                  }}
                />
              </a>
            </div> */}
          </div>
          <ul className="footer-sub-links">
            <li>
              <a href={PATHS.HOME}>Home</a>
            </li>
            <li>
              <span onClick={() => this.showReadBannerModal("termsConditions")}>
                Terms & Conditions
              </span>
            </li>
            <li>
              <span onClick={() => this.showReadBannerModal("privacyPolicy")}>
                Privacy Policy
              </span>
            </li>
            <li>
              <span onClick={() => this.showReadBannerModal("copyrightPolicy")}>
                Copyright Policy
              </span>
            </li>
            <li>
              <span
                onClick={() => this.showReadBannerModal("hyperlinkingPolicy")}
              >
                Hyperlinking Policy
              </span>
            </li>

            <li>
              {/* <span onClick={onClickNeedHelpModal} data-test="contact-us">
                Contact Us
              </span> */}
              <a href={PATHS.CONTACT_US_PAGE}>Contact Us</a>
            </li>
            <li>
              <a href={PATHS.FEEDBACK_PAGE}>Feedback</a>
            </li>
            <li>
              <a href={PATHS.SITEMAP}>Sitemap</a>
            </li>
          </ul>
          {showNeedHelpModal ? (
            <NeedHelpModal
              title={"Contact us"}
              show={true}
              closeModal={onClickNeedHelpModal}
              pmgInvestIndiaMail={pmgInvestIndiaMail}
              pmgSupportMail={pmgSupportMail}
            />
          ) : null}
          <div className="copyright">
            © Content Owned by Project Monitoring Group, Cabinet Secretariat
          </div>
        </div>

        {/* ---Modals In Footer---*/}
        {bannerContent === "termsConditions" ? (
          <TermsCondition
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "privacyPolicy" ? (
          <PrivacyPolicy
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "copyrightPolicy" ? (
          <CopyrightPolicy
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "hyperlinkingPolicy" ? (
          <HyperLinkingPolicy
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
      </footer>
    );
  }
}

export default Footer;
